import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class NovoUsuario extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.notificar = this.notificar.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.cadastrar = this.cadastrar.bind(this);
    this.validarCadastro = this.validarCadastro.bind(this);
    this.getDefaultUsuario = this.getDefaultUsuario.bind(this);
    this.handleChangeVendedor = this.handleChangeVendedor.bind(this);
    this.handleChangeTipoUsuario = this.handleChangeTipoUsuario.bind(this);

    this.state = {
      usuario: this.getDefaultUsuario(),
      errors: {
        desc: false,
        login: false,
        senha: false,
        senhaRepetir: false,
        email: false,
        celular: false,
        cargo: false,
        vendedores: [],
      },
      empresas: [],
      vendedoresSelecionados: [],
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    await axios
      .get(`${this.props.getBaseUrlApi()}/empresas`, this.props.parameters())
      .then((response) => {
        let empresas = response.data.empresas;

        this.setState(
          {
            empresas,
          },
          () => {
            let vendedoresSelecionados = this.state.vendedoresSelecionados;
            let errors = this.state.errors;
            let i = 0;

            for (let empresa of empresas) {
              vendedoresSelecionados[i] = {
                idIntegracaoEmpresa: empresa.idIntegracao,
                idIntegracaoVendedor: null,
              };
              errors.vendedores[i] = false;
              i++;
            }

            this.setState({ vendedoresSelecionados });
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  getDefaultUsuario() {
    return {
      desc: "",
      login: "",
      senha: "",
      senhaRepetir: "",
      email: "",
      celular: "",
      cargo: "",
      tipo: "web", //app, web
    };
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  handleChangeInput(value, tipo) {
    let usuario = this.state.usuario;
    usuario[tipo] = value;
    this.setState({ usuario });
  }

  async cadastrar() {
    if (!this.validarCadastro()) {
      this.notificar("warning", "Preencha todos os campos!");
      return false;
    }

    if (this.state.usuario.senha !== this.state.usuario.senhaRepetir) {
      this.notificar("warning", "As senhas não correspondem");
      return false;
    }

    let data = {
      usuario: this.state.usuario,
      vendedoresSelecionados: this.state.vendedoresSelecionados,
    };

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/usuarios`,
        data,
        this.props.parameters()
      )
      .then((response) => {
        this.notificar("success", "Usuário cadastrado com sucesso!");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        console.log(error);
        this.notificar("warning", error.response.data.erro);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  validarCadastro() {
    let errorsLocal = this.state.errors;
    let valido = true;

    if (this.state.usuario.desc === "") {
      errorsLocal.desc = true;
      valido = false;
    } else {
      errorsLocal.desc = false;
    }

    if (this.state.usuario.login === "") {
      errorsLocal.login = true;
      valido = false;
    } else {
      errorsLocal.login = false;
    }

    if (this.state.usuario.senha === "") {
      errorsLocal.senha = true;
      valido = false;
    } else {
      errorsLocal.senha = false;
    }

    if (this.state.usuario.senhaRepetir === "") {
      errorsLocal.senhaRepetir = true;
      valido = false;
    } else {
      errorsLocal.senhaRepetir = false;
    }

    if (this.state.usuario.email === "") {
      errorsLocal.email = true;
      valido = false;
    } else {
      errorsLocal.email = false;
    }

    if (this.state.usuario.celular === "") {
      errorsLocal.celular = true;
      valido = false;
    } else {
      errorsLocal.celular = false;
    }

    if (this.state.usuario.cargo === "") {
      errorsLocal.cargo = true;
      valido = false;
    } else {
      errorsLocal.cargo = false;
    }

    for (let i = 0; i < errorsLocal.vendedores.length; i++) {
      if (this.state.vendedoresSelecionados[i].idIntegracaoVendedor === null) {
        errorsLocal.vendedores[i] = true;
        valido = false;
      } else {
        errorsLocal.vendedores[i] = false;
      }
    }

    this.setState({ errors: errorsLocal });
    return valido;
  }

  handleChangeVendedor(value, idIntegracaoEmpresa) {
    if (value === "null") value = null;
    let vendedoresSelecionados = this.state.vendedoresSelecionados;

    for (let vendedorSelecionado of vendedoresSelecionados) {
      if (vendedorSelecionado.idIntegracaoEmpresa === idIntegracaoEmpresa) {
        vendedorSelecionado.idIntegracaoVendedor = parseInt(value);
      }
    }

    this.setState({ vendedoresSelecionados });
  }

  handleChangeTipoUsuario(e) {
    let value = e.target.value;
    this.setState({ usuario: { ...this.state.usuario, tipo: value } });
  }

  render() {
    return (
      <div id="contentSite">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <div className="container">
          <div
            style={{
              float: "left",
              width: "100%",
              padding: "0 20px",
              backgroundColor: "#fafbfc",
            }}
          >
            <div
              className=""
              style={{ float: "left", width: "100%", padding: "30px 10px" }}
            >
              <div className="d-flex flex-wrap w-100 float-left">
                <div className="col-6 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Descrição</label>
                    <input
                      type="text"
                      className={`form-control ${
                        this.state.errors.desc ? "input-error" : ""
                      }`}
                      value={this.state.usuario.desc}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "desc")
                      }
                    />
                  </div>
                </div>

                <div className="col-6 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Login</label>
                    <input
                      type="text"
                      className={`form-control ${
                        this.state.errors.login ? "input-error" : ""
                      }`}
                      value={this.state.usuario.login}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "login")
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex flex-wrap w-100 float-left">
                <div className="col-6 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Senha</label>
                    <input
                      type="password"
                      className={`form-control ${
                        this.state.errors.senha ? "input-error" : ""
                      }`}
                      value={this.state.usuario.senha}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "senha")
                      }
                    />
                  </div>
                </div>

                <div className="col-6 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Repetir Senha</label>
                    <input
                      type="password"
                      className={`form-control ${
                        this.state.errors.senhaRepetir ? "input-error" : ""
                      }`}
                      value={this.state.usuario.senhaRepetir}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "senhaRepetir")
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex flex-wrap w-100 float-left">
                <div className="col-6 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="text"
                      className={`form-control ${
                        this.state.errors.email ? "input-error" : ""
                      }`}
                      value={this.state.usuario.email}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "email")
                      }
                    />
                  </div>
                </div>

                <div className="col-6 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Celular</label>
                    <input
                      type="text"
                      className={`form-control ${
                        this.state.errors.celular ? "input-error" : ""
                      }`}
                      value={this.state.usuario.celular}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "celular")
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex flex-wrap w-100 float-left">
                <div className="col-6 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Cargo</label>
                    <input
                      type="text"
                      className={`form-control ${
                        this.state.errors.cargo ? "input-error" : ""
                      }`}
                      value={this.state.usuario.cargo}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "cargo")
                      }
                    />
                  </div>
                </div>
                <div className="col-6 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Tipo</label>
                    {/* <input
                      type="text"
                      className={`form-control ${
                        this.state.errors.cargo ? "input-error" : ""
                      }`}
                      value={this.state.usuario.cargo}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "cargo")
                      }
                    /> */}
                    <select
                      className="form-control"
                      value={this.state.usuario.tipo}
                      onChange={(e) => {
                        this.handleChangeTipoUsuario(e);
                      }}
                    >
                      <option value="app">APP</option>
                      <option value="web">WEB</option>
                    </select>
                  </div>
                </div>
              </div>

              {this.state.vendedoresSelecionados.length > 0 &&
                this.state.empresas.map((empresa, key) => (
                  <div className="form-group" key={key}>
                    <label>
                      {empresa.idIntegracao} - {empresa.fantasia}
                    </label>
                    <select
                      value={
                        this.state.vendedoresSelecionados[key]
                          .idIntegracaoVendedor
                      }
                      onChange={(e) =>
                        this.handleChangeVendedor(
                          e.target.value,
                          empresa.idIntegracao
                        )
                      }
                      className={`form-control ${
                        this.state.errors.vendedores[key] ? "input-error" : ""
                      }`}
                    >
                      <option value={"null"}>Escolher vendedor</option>
                      {empresa.vendedores.map((vendedor, key) => (
                        <option value={vendedor.idIntegracao} key={key}>
                          {vendedor.desc}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}

              <div className="form-group">
                <button className="btn btn-success" onClick={this.cadastrar}>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                  &nbsp; Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NovoUsuario;
